import { render, staticRenderFns } from "./HelpPanel.vue?vue&type=template&id=382e7e73&"
import script from "./HelpPanel.vue?vue&type=script&lang=ts&"
export * from "./HelpPanel.vue?vue&type=script&lang=ts&"
import style0 from "./HelpPanel.vue?vue&type=style&index=0&id=382e7e73&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports